<template>
  <scroll-right-frame>
    <div class="face-stats-container">
      <!-- 筛选控制区 -->
      <el-card class="filter-card" shadow="never">
        <div class="filter-panel">
          <!-- 筛选条件行 -->
          <el-row :gutter="20" class="filter-row">
            <el-col :span="7">
              <div class="filter-item">
                <label class="filter-label">日期范围：</label>
                <el-date-picker
                  v-model="filters.dateRange"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  @change="onDateRangeChange">
                </el-date-picker>
              </div>
            </el-col>

            <el-col :span="6">
              <div class="filter-item">
                <label class="filter-label">产品线：</label>
                <el-select
                  v-model="filters.productLineIds"
                  multiple
                  placeholder="请选择产品线"
                  clearable
                  collapse-tags
                  @change="onFilterChange">
                  <el-option
                    v-for="pl in filterOptions.productLines"
                    :key="pl.id"
                    :label="pl.name"
                    :value="pl.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>

            <el-col :span="5">
              <div class="filter-item">
                <label class="filter-label">服务商：</label>
                <el-select
                  v-model="filters.providers"
                  multiple
                  placeholder="请选择服务商"
                  clearable
                  collapse-tags
                  @change="onFilterChange">
                  <el-option label="腾讯" value="tencent"></el-option>
                  <el-option label="百度" value="baidu"></el-option>
                  <el-option label="旷视" value="megvii"></el-option>
                </el-select>
              </div>
            </el-col>

            <el-col :span="6">
              <div class="filter-item">
                <label class="filter-label">功能类型：</label>
                <el-select
                  v-model="filters.functionTypes"
                  multiple
                  placeholder="请选择功能"
                  clearable
                  collapse-tags
                  @change="onFilterChange">
                  <el-option label="人脸对比" value="face_compare"></el-option>
                  <el-option label="静态活体" value="static_live"></el-option>
                  <el-option label="动态活体" value="dynamic_live"></el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>

          <!-- 操作按钮行 -->
          <el-row :gutter="20" class="button-row">
            <el-col :span="24" class="filter-buttons">
              <el-button type="primary" icon="el-icon-search" @click="loadChartsData">查询</el-button>
              <el-button icon="el-icon-refresh" @click="resetFilters">重置</el-button>
              <el-button
                type="success"
                icon="el-icon-refresh-right"
                :loading="loading"
                @click="refreshData">
                刷新数据
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-card>

      <!-- 统计卡片区 -->
      <el-row :gutter="20" class="stats-cards">
        <el-col :span="6">
          <el-card class="stats-card" shadow="hover">
            <div class="stats-item">
              <div class="stats-icon total-icon">
                <i class="el-icon-data-line"></i>
              </div>
              <div class="stats-content">
                <div class="stats-value">{{ formatNumber(overview.totalTimes || 0) }}</div>
                <div class="stats-label">
                  总调用次数
                  <el-tooltip placement="top" effect="light">
                    <div slot="content" style="max-width: 250px;">
                      所有人脸识别服务（人脸对比、静态活体、动态活体）的总调用次数
                    </div>
                    <i class="el-icon-question stats-help-icon"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="stats-card" shadow="hover">
            <div class="stats-item">
              <div class="stats-icon fee-icon">
                <i class="el-icon-coin"></i>
              </div>
              <div class="stats-content">
                <div class="stats-value">¥{{ formatMoney(overview.totalFee || 0) }}</div>
                <div class="stats-label">
                  总费用
                  <el-tooltip placement="top" effect="light">
                    <div slot="content" style="max-width: 250px;">
                      所有人脸识别服务产生的总费用金额
                    </div>
                    <i class="el-icon-question stats-help-icon"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="stats-card" shadow="hover">
            <div class="stats-item">
              <div class="stats-icon customer-icon">
                <i class="el-icon-user"></i>
              </div>
              <div class="stats-content">
                <div class="stats-value">{{ overview.uniqueCustomers || 0 }}</div>
                <div class="stats-label">
                  活跃客户数
                  <el-tooltip placement="top" effect="light">
                    <div slot="content" style="max-width: 250px;">
                      使用过人脸识别服务的不重复客户数量
                    </div>
                    <i class="el-icon-question stats-help-icon"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="stats-card" shadow="hover">
            <div class="stats-item">
              <div class="stats-icon avg-icon">
                <i class="el-icon-money"></i>
              </div>
              <div class="stats-content">
                <div class="stats-value">¥{{ formatAvgPrice(overview.avgPrice || 0) }}</div>
                <div class="stats-label">
                  平均单价
                  <el-tooltip placement="top" effect="light">
                    <div slot="content" style="max-width: 250px;">
                      总费用 ÷ 总调用次数<br/>
                      反映平均每次调用的成本
                    </div>
                    <i class="el-icon-question stats-help-icon"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 图表区域 - 第一行 -->
      <el-row :gutter="20" class="charts-row">
        <el-col :span="8">
          <el-card class="chart-card" shadow="never">
            <div slot="header" class="chart-header">
              <span>服务商使用分布</span>
              <el-tooltip placement="top" effect="light">
                <div slot="content" style="max-width: 300px;">
                  <strong>功能说明：</strong><br/>
                  展示各服务商（腾讯、百度、旷视）的调用次数分布情况，帮助了解各服务商的使用占比。
                </div>
                <i class="el-icon-question chart-help-icon"></i>
              </el-tooltip>
            </div>
            <provider-pie-chart :data="providerData" :loading="loading" />
          </el-card>
        </el-col>

        <el-col :span="8">
          <el-card class="chart-card" shadow="never">
            <div slot="header" class="chart-header">
              <span>功能类型分布</span>
              <el-tooltip placement="top" effect="light">
                <div slot="content" style="max-width: 300px;">
                  <strong>功能说明：</strong><br/>
                  展示不同功能类型（人脸对比、静态活体、动态活体）的使用分布，帮助了解各功能的使用情况。
                </div>
                <i class="el-icon-question chart-help-icon"></i>
              </el-tooltip>
            </div>
            <function-pie-chart :data="functionData" :loading="loading" />
          </el-card>
        </el-col>

        <el-col :span="8">
          <el-card class="chart-card" shadow="never">
            <div slot="header" class="chart-header">
              <span>Top 10 客户排行</span>
              <el-tooltip placement="top" effect="light">
                <div slot="content" style="max-width: 300px;">
                  <strong>功能说明：</strong><br/>
                  展示调用次数最多的前10位客户，帮助识别重点用户。
                </div>
                <i class="el-icon-question chart-help-icon"></i>
              </el-tooltip>
            </div>
            <top-customers-chart :data="topCustomersData" :loading="loading" />
          </el-card>
        </el-col>
      </el-row>

      <!-- 图表区域 - 第二行 -->
      <el-row :gutter="20" class="charts-row">
        <el-col :span="24">
          <el-card class="chart-card" shadow="never">
            <div slot="header" class="chart-header">
              <span>使用量趋势分析</span>
              <el-tooltip placement="top" effect="light">
                <div slot="content" style="max-width: 300px;">
                  <strong>功能说明：</strong><br/>
                  展示各服务功能的使用量随时间的变化趋势，帮助分析使用模式和增长情况。
                </div>
                <i class="el-icon-question chart-help-icon"></i>
              </el-tooltip>
            </div>
            <trend-line-chart :data="trendData" :loading="loading" />
          </el-card>
        </el-col>
      </el-row>

      <!-- 图表区域 - 第三行 -->
      <el-row :gutter="20" class="charts-row">
        <el-col :span="24">
          <el-card class="chart-card" shadow="never">
            <div slot="header" class="chart-header">
              <span>产品线分布统计</span>
              <el-tooltip placement="top" effect="light">
                <div slot="content" style="max-width: 300px;">
                  <strong>功能说明：</strong><br/>
                  展示各产品线的调用次数和费用分布，柱状图表示调用次数，折线图表示费用金额。
                </div>
                <i class="el-icon-question chart-help-icon"></i>
              </el-tooltip>
            </div>
            <product-line-chart :data="productLineData" :loading="loading" />
          </el-card>
        </el-col>
      </el-row>
    </div>
  </scroll-right-frame>
</template>

<script>
import util from '../../../../libs/util'
import ScrollRightFrame from '../../../../components/scroll-right-frame.vue'
import ProviderPieChart from './components/provider-pie-chart.vue'
import FunctionPieChart from './components/function-pie-chart.vue'
import TopCustomersChart from './components/top-customers-chart.vue'
import TrendLineChart from './components/trend-line-chart.vue'
import ProductLineChart from './components/product-line-chart.vue'

export default {
  name: 'FaceStats',
  components: {
    ScrollRightFrame,
    ProviderPieChart,
    FunctionPieChart,
    TopCustomersChart,
    TrendLineChart,
    ProductLineChart
  },
  data() {
    return {
      loading: false,
      filters: {
        dateRange: [],
        productLineIds: [],
        providers: [],
        functionTypes: []
      },
      filterOptions: {
        productLines: []
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '本月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setDate(1)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      overview: {},
      providerData: [],
      functionData: [],
      topCustomersData: [],
      trendData: {},
      productLineData: {}
    }
  },
  computed: {},
  created() {
    this.initFilters()
    this.loadFilterOptions()
    this.loadChartsData()
  },
  methods: {
    /**
     * 初始化筛选条件（默认选中本月）
     */
    initFilters() {
      const end = new Date()
      const start = new Date()
      start.setDate(1)

      this.filters.dateRange = [
        this.formatDate(start),
        this.formatDate(end)
      ]
    },

    /**
     * 加载筛选选项
     */
    async loadFilterOptions() {
      try {
        const response = await util.ajax.get('/entity/stats/face/filter-options')
        if (response.data.meta.errCode === 0) {
          this.filterOptions.productLines = response.data.data.productLines || []
        }
      } catch (error) {
        console.error('加载筛选选项失败:', error)
        this.$message.error('加载筛选选项失败: ' + error.message)
      }
    },

    /**
     * 加载图表数据
     */
    async loadChartsData() {
      if (!this.filters.dateRange || this.filters.dateRange.length !== 2) {
        this.$message.warning('请选择日期范围')
        return
      }

      this.loading = true
      try {
        const params = {
          startDate: this.filters.dateRange[0],
          endDate: this.filters.dateRange[1],
          productLineIds: this.filters.productLineIds,
          providers: this.filters.providers,
          functionTypes: this.filters.functionTypes
        }

        const response = await util.ajax.post('/entity/stats/face/charts', params)
        if (response.data.meta.errCode === 0) {
          const data = response.data.data
          this.overview = data.overview || {}
          this.providerData = data.providerData || []
          this.functionData = data.functionData || []
          this.topCustomersData = data.topCustomersData || []
          this.trendData = data.trendData || {}
          this.productLineData = data.productLineData || {}
        } else {
          this.$message.error('数据加载失败: ' + response.data.meta.errMsg)
        }
      } catch (error) {
        console.error('加载图表数据失败:', error)
        this.$message.error('加载图表数据失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },

    /**
     * 重置筛选条件
     */
    resetFilters() {
      this.initFilters()
      this.filters.productLineIds = []
      this.filters.providers = []
      this.filters.functionTypes = []
      this.loadChartsData()
    },

    /**
     * 刷新数据
     */
    refreshData() {
      this.loadChartsData()
    },

    /**
     * 日期范围变化
     */
    onDateRangeChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.loadChartsData()
      }
    },

    /**
     * 筛选条件变化
     */
    onFilterChange() {
      this.loadChartsData()
    },

    /**
     * 格式化日期
     */
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    /**
     * 格式化数字（添加千分位）
     */
    formatNumber(num) {
      if (num === null || num === undefined) return '0'
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    /**
     * 格式化金额
     */
    formatMoney(amount) {
      if (amount === null || amount === undefined) return '0.00'
      return parseFloat(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    /**
     * 格式化平均单价（保留更多小数位）
     */
    formatAvgPrice(amount) {
      if (amount === null || amount === undefined) return '0.00000'
      const num = parseFloat(amount)
      if (num === 0) return '0.00000'

      // 保留5位小数
      return num.toFixed(5)
    }
  }
}
</script>

<style scoped>
/* 容器样式 - 防止横向滚动 */
.face-stats-container {
  padding: 0 10px 0 0;
  background: linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%);
  min-height: 100vh;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* 防止Element UI默认边距导致横向滚动 */
.el-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.el-col {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

/* 确保所有卡片不超出容器 */
.filter-card,
.stats-card,
.chart-card {
  max-width: 100%;
  box-sizing: border-box;
}

/* 筛选区域样式 */
.filter-card {
  margin-bottom: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
}

.filter-card:hover {
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.12);
}

.filter-card /deep/ .el-card__body {
  padding: 24px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

.filter-panel {
  padding: 0;
}

.filter-row {
  margin-bottom: 0;
}

.button-row {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}

.filter-item {
  display: flex;
  align-items: center;
  width: 100%;
}

.filter-label {
  flex-shrink: 0;
  width: 90px;
  font-weight: 600;
  color: #303133;
  font-size: 14px;
  text-align: right;
  padding-right: 12px;
}

.filter-item /deep/ .el-date-editor,
.filter-item /deep/ .el-select {
  flex: 1;
}

.filter-buttons {
  text-align: left;
}

.filter-buttons .el-button {
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.filter-buttons .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 统计卡片样式 */
.stats-cards {
  margin-bottom: 24px;
}

.stats-card {
  border-radius: 12px;
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
}

.stats-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.stats-card /deep/ .el-card__body {
  padding: 20px;
}

.stats-item {
  display: flex;
  align-items: center;
}

.stats-icon {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: white;
  margin-right: 16px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.stats-card:hover .stats-icon {
  transform: scale(1.1) rotate(5deg);
}

.total-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.fee-icon {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  box-shadow: 0 4px 12px rgba(67, 233, 123, 0.3);
}

.customer-icon {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  box-shadow: 0 4px 12px rgba(250, 112, 154, 0.3);
}

.avg-icon {
  background: linear-gradient(135deg, #30cfd0 0%, #330867 100%);
  box-shadow: 0 4px 12px rgba(48, 207, 208, 0.3);
}

.stats-content {
  flex: 1;
  min-width: 0;
}

.stats-value {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
  line-height: 1.2;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stats-label {
  font-size: 14px;
  color: #606266;
  display: flex;
  align-items: center;
  font-weight: 500;
}

.stats-help-icon {
  font-size: 14px;
  color: #c0c4cc;
  cursor: help;
  margin-left: 6px;
  transition: all 0.3s ease;
}

.stats-help-icon:hover {
  color: #667eea;
  transform: scale(1.15);
}

/* 图表区域样式 */
.charts-row {
  margin-bottom: 24px;
}

.chart-card {
  border-radius: 12px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
}

.chart-card:hover {
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.12);
}

.chart-card /deep/ .el-card__header {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-bottom: 1px solid #ebeef5;
  padding: 16px 20px;
}

.chart-card /deep/ .el-card__body {
  padding: 16px;
}

.chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  color: #303133;
  font-size: 15px;
}

.chart-help-icon {
  font-size: 16px;
  color: #909399;
  cursor: help;
  transition: all 0.3s ease;
  margin-left: 8px;
}

.chart-help-icon:hover {
  color: #667eea;
  transform: scale(1.2);
}
</style>




// WEBPACK FOOTER //
// src/custom/components/stats/face-stats/face-stats.vue